import { render, staticRenderFns } from "./ListProductRequireToNhanh.vue?vue&type=template&id=cf587f62&"
import script from "./ListProductRequireToNhanh.vue?vue&type=script&lang=js&"
export * from "./ListProductRequireToNhanh.vue?vue&type=script&lang=js&"
import style0 from "./ListProductRequireToNhanh.vue?vue&type=style&index=0&id=cf587f62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports